import { JsonPipe } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutingService } from '@r1-compass-library/services';

type assetIdCases = 'withId' | 'withNew' | 'without';

@Component({
    selector: 'r1-compass-app-routing-debug',
    imports: [JsonPipe],
    template: `
        @switch (assetId()) {
            @case ('withId') {
                <button (click)="changeRoute('withNew')">With "New" as ID</button>
                <button (click)="changeRoute('without')">Without Asset ID</button>
            }
            @case ('withNew') {
                <button (click)="changeRoute('withId')">With Asset ID</button>
                <button (click)="changeRoute('without')">Without Asset ID</button>
            }
            @case ('without') {
                <button (click)="changeRoute('withId')">With Asset ID</button>
                <button (click)="changeRoute('withNew')">With "New" as ID</button>
            }
        }
        <pre>currentRoute: {{ routingService.currentRoute() }}</pre>
        <pre>currentRoutePieces: {{ routingService.currentRoutePieces() | json }}</pre>
        <pre>restOfRoute: {{ routingService.restOfRoute() }}</pre>
        <pre>routeDisabledUntilAssetCreated: {{ routingService.routeDisabledUntilAssetCreated() }}</pre>
        <pre>topRoute: {{ routingService.topRoute() }}</pre>

        <button (click)="changeRouteParams('with')">With router params</button>
        <button (click)="changeRouteParams('without')">Without router params</button>
    `,
    styles: ``,
})
export class RoutingDebugComponent implements OnInit {
    protected readonly routingService = inject(RoutingService);
    readonly #router = inject(Router);
    readonly #route = inject(ActivatedRoute);

    assetId = signal<assetIdCases>('without');
    routeParams = signal<'' | 'whoa'>('');

    changeRouteParams(withOrWithout: 'with' | 'without') {
        switch (withOrWithout) {
            case 'with':
                this.#router.navigate([], { relativeTo: this.#route, queryParams: { folderId: 0 } });
                break;
            case 'without':
                this.#router.navigate([], { relativeTo: this.#route });
                break;
        }
    }

    ngOnInit() {
        // Sync with default on reload
        this.#router.navigate(['debug/routing-debug']);
    }

    changeRoute(withOrWithout: assetIdCases) {
        switch (withOrWithout) {
            case 'withId':
                this.assetId.set('withId');
                this.#router.navigate(['routing-debug/3/section']);
                break;
            case 'withNew':
                this.assetId.set('withNew');
                this.#router.navigate(['routing-debug/new/section']);
                break;
            case 'without':
                this.assetId.set('without');
                this.#router.navigate(['routing-debug']);
                break;
        }
    }
}
